module.exports = __webpack_public_path__ + "img/nshop_logo.5a28ccae.png";